module.exports = __webpack_public_path__ + "img/banklogo-6.6c657a6d.png";